function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Circle } from '@chakra-ui/react';
import { Box, Flex, Spinner, TapTheme } from '@tapresearch/ui/components';
import React from 'react';
import { useGetCampaignHealthStatusQuery } from '../store/api';
import { getCampaignHealthStatus } from '../store/campaigns/selectors/getCampaignHealthStatus';
import { useAppSelector } from '../store/hooks';
var statusColor = {
    Pass: TapTheme.colors.green[500],
    Ok: TapTheme.colors.green[500],
    Minor: TapTheme.colors.orange[200],
    Serious: TapTheme.colors.orange[700],
    Critical: TapTheme.colors.red[500]
};
var statusIndex = {
    Pass: 0,
    Ok: 1,
    Minor: 2,
    Serious: 3,
    Critical: 4
};
export function CampaignHealthStatus(_param) {
    var campaignId = _param.campaignId, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, flexProps = _object_without_properties(_param, [
        "campaignId",
        "disabled"
    ]);
    var isLoading = useGetCampaignHealthStatusQuery({
        id: campaignId.toString()
    }, {
        pollingInterval: window.tapiConfig.requests.healthStatus.pollingInterval,
        skip: disabled
    }).isLoading;
    var healthStatus = useAppSelector(function(state) {
        return getCampaignHealthStatus(state, campaignId);
    });
    var showLoading = isLoading && !healthStatus;
    return /*#__PURE__*/ React.createElement(Flex, flexProps, showLoading ? /*#__PURE__*/ React.createElement(Spinner, {
        "data-testid": "health-status-loading",
        size: "sm"
    }) : /*#__PURE__*/ React.createElement(Circle, {
        size: 4,
        backgroundColor: disabled ? TapTheme.colors.gray[500] : statusColor[healthStatus],
        "data-testid": "health-status-".concat(healthStatus)
    }, /*#__PURE__*/ React.createElement(Box, {
        display: "none"
    }, " ", statusIndex[healthStatus], " ")));
}
